import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { mainSiteUrl, seoKeywords } from '@/mocks/categories';
import { SITE_URL } from '@/constants';

const siteUrl = SITE_URL;
const articleUrl = `${siteUrl}/itaobuy-spreadsheet-confronto`;

const confrontoJsonLd = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": "Itaobuy Spreadsheet vs Alternative: Confronto Completo 2026",
  "description": "Un confronto imparziale e dettagliato tra Itaobuy Spreadsheet e le principali alternative sul mercato. Funzionalità, prezzi, sicurezza e molto altro per aiutarti a scegliere lo strumento giusto.",
  "image": "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20two%20laptops%20side%20by%20side%20showing%20different%20spreadsheet%20interfaces%2C%20comparison%20concept%2C%20on%20light%20grey%20concrete%20desk%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%2C%20clean%20sophisticated%20composition&width=800&height=600&seq=confronto-hero&orientation=landscape",
  "datePublished": "2026-07-14",
  "dateModified": "2026-07-14",
  "author": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Itaobuy Spreadsheet Italia",
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg"
    }
  },
  "url": articleUrl,
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": articleUrl
  },
  "inLanguage": "it"
};

export default function ConfrontoPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(confrontoJsonLd)
        }}
      />
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-background-100">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="flex items-center justify-between h-16 md:h-20">
            <a href="/" className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight hover:opacity-80 transition-opacity whitespace-nowrap">
              Itaobuy<span className="italic font-normal text-primary-500">Spreadsheet</span>
            </a>
            <div className="hidden md:flex items-center gap-5">
              <a href="/" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Home</a>
              <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guida Acquisti</a>
              <a href="/itaobuy-spreadsheet-guida" className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap">Guida</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="px-5 py-2 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">Buy It Now</a>
            </div>
          </div>
        </div>
      </nav>

      <section className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
            <div className="flex-1">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="Breadcrumb">
                <a href="/" className="hover:text-primary-500 transition-colors">Home</a>
                <span className="w-4 h-4 flex items-center justify-center">/</span>
                <span className="text-foreground-400">Confronto</span>
              </nav>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 leading-tight mb-6">
                Itaobuy Spreadsheet{' '}
                <span className="italic text-primary-500">vs Alternative 2026</span>
              </h1>
              <div className="flex items-center gap-3 text-sm text-foreground-500 mb-6">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                <span>Aggiornato: Luglio 2026</span>
                <span className="text-foreground-300">|</span>
                <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                <span>16 minuti di lettura</span>
              </div>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl">
                Un confronto imparziale e dettagliato tra Itaobuy Spreadsheet e le principali
                alternative sul mercato. Funzionalità, prezzi, sicurezza e molto altro per
                aiutarti a scegliere lo strumento giusto.
              </p>
              <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-white rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                Torna alla Home
              </button>
            </div>
            <div className="flex-1">
              <div className="rounded-2xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20two%20laptops%20side%20by%20side%20showing%20different%20spreadsheet%20interfaces%2C%20comparison%20concept%2C%20on%20light%20grey%20concrete%20desk%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%2C%20clean%20sophisticated%20composition&width=800&height=600&seq=confronto-hero&orientation=landscape" className="w-full h-full object-cover" alt="Confronto Itaobuy Spreadsheet" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto">
          <article className="space-y-16">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">1. Tabella Comparativa Completa</h2>
              <div className="overflow-x-auto rounded-xl border border-background-200/70">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-background-50">
                      <th className="text-left py-4 px-5 font-semibold text-foreground-900">Funzionalità</th>
                      <th className="text-left py-4 px-5 font-semibold text-primary-600">Itaobuy Spreadsheet</th>
                      <th className="text-left py-4 px-5 font-semibold text-foreground-600">Excel</th>
                      <th className="text-left py-4 px-5 font-semibold text-foreground-600">Google Sheets</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-background-100">
                    {[
                      { feature: 'Facilità utilizzo', i: 'Molto alta', e: 'Media', g: 'Alta' },
                      { feature: 'Collaborazione', i: 'Tempo reale', e: 'Limitata', g: 'Tempo reale' },
                      { feature: 'Automazioni', i: 'Avanzate', e: 'Macro VBA', g: 'Google Apps Script' },
                      { feature: 'Crittografia', i: 'AES-256', e: 'AES-256', g: 'AES-256' },
                      { feature: 'Backup auto', i: 'Giornaliero', e: 'Manuale', g: 'Continuo' },
                      { feature: 'Prezzo', i: 'Competitivo', e: 'Abbonamento', g: 'Gratuito base' },
                      { feature: 'Offline', i: 'Disponibile', e: 'Completo', g: 'Limitato' },
                      { feature: 'Template', i: '50+', e: '100+', g: '30+' },
                    ].map((row, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-background-50/50'}>
                        <td className="py-3 px-5 text-foreground-700 font-medium">{row.feature}</td>
                        <td className="py-3 px-5 text-primary-600 font-semibold">{row.i}</td>
                        <td className="py-3 px-5 text-foreground-500">{row.e}</td>
                        <td className="py-3 px-5 text-foreground-500">{row.g}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">2. Analisi Approfondita</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>Quando si confronta <strong>Itaobuy Spreadsheet</strong> con Excel e Google Sheets, emergono differenze significative in termini di approccio e filosofia. Mentre Excel rimane il punto di riferimento per la potenza pura delle funzionalità desktop, e Google Sheets eccelle nella semplicità e nell&apos;integrazione con l&apos;ecosistema Google, <strong>Itaobuy Sheet</strong> si posiziona come il compromesso ideale: potente come Excel ma collaborativo come Google Sheets.</p>
                <p>Per un&apos;analisi ancora più dettagliata delle funzionalità, consulta la nostra <a href="/itaobuy-spreadsheet-guida" className="text-primary-500 hover:text-primary-600 font-medium">guida completa</a>. Se invece ti interessa la sicurezza, abbiamo una <a href="/itaobuy-spreadsheet-sicurezza" className="text-primary-500 hover:text-primary-600 font-medium">pagina dedicata</a> con tutti i dettagli.</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">3. Quale Scegliere nel 2026?</h2>
              <div className="space-y-4 text-foreground-700 leading-relaxed">
                <p>La scelta dipende dalle tue esigenze specifiche. Se lavori principalmente in team e hai bisogno di collaborazione fluida con automazioni intelligenti, <strong>Itaobuy Spreadsheet</strong> è la scelta migliore. Se invece hai bisogno della massima potenza di calcolo offline e funzioni statistiche avanzatissime, Excel potrebbe essere più adatto. Per progetti semplici e condivisione rapida, Google Sheets rimane un&apos;ottima opzione gratuita.</p>
                <p>Nel complesso, per la maggior parte degli utenti italiani, <strong>Itaobuy Sheet</strong> rappresenta il miglior rapporto qualità-prezzo, combinando un&apos;interfaccia moderna con funzionalità professionali a un costo accessibile. Leggi anche la nostra <a href="/itaobuy-spreadsheet-recensione" className="text-primary-500 hover:text-primary-600 font-medium">recensione completa</a> per scoprire le opinioni degli utenti.</p>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mb-12">Articoli Correlati</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            {[{ title: 'Guida Completa 2026', url: '/itaobuy-spreadsheet-guida', icon: 'ri-book-open-line' }, { title: 'Sicurezza e Privacy', url: '/itaobuy-spreadsheet-sicurezza', icon: 'ri-shield-check-line' }, { title: 'Guida Acquisti', url: '/itaobuy-spreadsheet-guida-acquisti', icon: 'ri-shopping-bag-3-line' }].map((item, i) => (
              <a key={i} href={item.url} className="p-6 rounded-xl bg-white border border-background-200/70 hover:shadow-md transition-all group cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-sky-50 flex items-center justify-center text-sky-500 mx-auto mb-4 group-hover:bg-sky-100 transition-colors">
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-sky-500 transition-colors">{item.title}</h3>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-background-50">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
          <p className="text-foreground-500 text-sm mb-4">
            Torna alla homepage per esplorare tutte le guide e le risorse su
            <a href="/" className="text-primary-500 hover:text-primary-600 font-medium ml-1">Itaobuy Spreadsheet Italia</a>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-400">
            {seoKeywords.map((kw, idx) => (
              <span key={idx} className="px-3 py-1 rounded-full bg-white border border-background-200">{kw}</span>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-accent-900 text-white">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
          <div className="py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <a href="/" className="font-heading text-2xl font-semibold text-white tracking-tight inline-block mb-4">Itaobuy<span className="italic font-normal text-accent-300">Spreadsheet</span></a>
              <p className="text-white/50 text-sm max-w-xs">La guida italiana più completa su Itaobuy Spreadsheet. Guide, recensioni, tutorial e confronti aggiornati.</p>
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <a href="/" className="text-white/60 text-sm hover:text-white transition-colors">Home</a>
                <a href="/itaobuy-spreadsheet-guida" className="text-white/60 text-sm hover:text-white transition-colors">Guida Completa</a>
                <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-white/60 text-sm hover:text-white transition-colors">Guida Acquisti</a>
              </div>
              <div className="flex flex-col gap-2">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Buy It Now</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Cookie Policy</a>
              </div>
            </div>
          </div>
          <div className="py-5 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/40 text-xs">&copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia.</p>
            <div className="flex items-center gap-3">
              {['ri-facebook-line', 'ri-twitter-x-line', 'ri-instagram-line'].map((icon) => (
                <a key={icon} href="#" className="w-7 h-7 rounded-md border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/40 transition-colors">
                  <i className={`${icon} w-3 h-3 flex items-center justify-center`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}